import * as ReactDOM from "react-dom/client";
import CssBaseline from "@mui/material/CssBaseline";
import App from "./App";
import { ThemeContextProvider } from "./contexts/ThemeContext";
import { muiXLicenseKey } from "./config";
import { LicenseInfo } from "@mui/x-license";
import HyperDXInitializer from "@/components/tools/HyperDXInitializer";
import "@fontsource/inter";
import "./config/firebase";
// import { ReactScan } from "./components/ReactScan";

if (muiXLicenseKey) {
  LicenseInfo.setLicenseKey(muiXLicenseKey);
} else {
  console.error("MUI X License Key is not set: ", muiXLicenseKey);
}

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement!);

root.render(
  <ThemeContextProvider>
    <CssBaseline />
    <HyperDXInitializer />
    {/* <ReactScan /> */}
    <App />
  </ThemeContextProvider>
);
